import { useEFoodConfig } from "../useEFoodConfig";

const useIsAutoLoginAllowed = () => {
  const eFoodConfig = useEFoodConfig();

  return eFoodConfig.isAutoLoginAllowed === true;
};

export default useIsAutoLoginAllowed;
